import { Button, Text } from "@softmax/design-system";

export type AccountRecoveryState = {
  readonly refreshing: boolean;
  readonly message?: string;
};

export function AccountRecovery({
  recovery,
  resource,
  onRefresh,
  size = "md",
}: {
  readonly recovery: AccountRecoveryState;
  readonly resource: "photo" | "players" | "credentials";
  readonly onRefresh: (() => void) | undefined;
  readonly size?: "sm" | "md";
}) {
  return (
    <>
      <Button
        type="button"
        size={size}
        aria-disabled={recovery.refreshing}
        onClick={onRefresh}
      >
        {recovery.refreshing
          ? `Refreshing ${resource}…`
          : `Refresh ${resource}`}
      </Button>
      {recovery.message ? (
        <Text as="p" size="small">
          {recovery.message}
        </Text>
      ) : null}
    </>
  );
}
